import LazyLoad from "vanilla-lazyload";

interface ILazyLoaderConfig {
  lazyLoad: typeof LazyLoad,
  selectors: ILazyLoaderSelector
  classNames: ILazyLoaderClassNames;
}

interface ILazyLoaderSelector {
  element: string
}

interface ILazyLoaderClassNames {
  lazy: string
}

class LazyLoader {

  private config:ILazyLoaderConfig;

  constructor() {
    this.config = {
      lazyLoad: null,
      classNames: {
        lazy: 'lazy'
      },
      selectors: {
        element: '.lazy'
      }
    }
  }

  public init() {
    this.config.lazyLoad = new LazyLoad({
      elements_selector: this.config.selectors.element,
      container: document.querySelector('body')
    });
  }

  public update() {
    this.config.lazyLoad.update();
  }

  public add(nodeList:NodeList) {
    nodeList.forEach((node:HTMLElement) => node.classList.add('lazy'));
  }
}

export default new LazyLoader();